<template>
	<li class="test__item">
		<p v-html="question.question"></p>
		<ul class="test__sub-item">
			<li class="test__option">
				<label class="option">
					<input
						:value="question.option_a"
						:name="`question-${question.id}`" 
						type="radio"
						v-model="answer"
						@click="setAnswer(question.option_a, 'option_a')">
					<span class="text" v-html="question.option_a"></span>
					<span
						class="radio">
						a</span>
				</label>
			</li>
			<li class="test__option">
				<label class="option">
					<input
						:value="question.option_b" 
						:name="`question-${question.id}`" 
						type="radio"
						v-model="answer"
						@click="setAnswer(question.option_b, 'option_b')">
					<span class="text" v-html="question.option_b"></span>
					<span
						class="radio">
						b</span>
				</label>
			</li>
		</ul>
	</li>	
</template>

<script>
import { mapMutations } from 'vuex';
import eventHub from '../../utils/eventhub';

export default {
	name: 'Question',
	props: {
		question: {
			type: Object,
			default() {
				return {
				};
			}
		}
	},
	data() {
		return {
			option: '',
			answer: '',
			isAnswered: false,
			isCorrect: false,
			resp: {}
		};
	},
	watch: {
		isCorrect(value) {
			if (value) {
				this.setScore();
			}
		},
		answer(value) {
			this.resp = {
				question_id: this.question.id,
				response: this.option
			};
			this.emitResponse();
		}
	},
	methods: {
		emitResponse() {
			eventHub.$emit('response', this.resp);
		},
		...mapMutations([
			'setScore',
			'setAnsweredQuestions'
		]),
		setAnswer(answer, option) {
			if (!this.isAnswered) {
				this.setAnsweredQuestions();
			}
			this.option = option;
			this.isAnswered = true;
			this.isCorrect = answer === this.question.answer;
			return this.answer === this.question.answer;
		}
	}
};
</script>


<style lang="scss" scoped>
.text {
	display: inline;
}
.option:hover input:disabled ~ .radio {
	cursor: not-allowed!important;
}
.option:hover input:disabled ~ .text {
	cursor: not-allowed!important;
}
.test__option .option input:checked + .error {
	color: red!important;
}
.radio.error {
	background: red!important;
	border-color: red!important;
}
.error {
	color: red;
}
.go {
	color: $green;
}
.test__sub-item {
    margin-top: 15px;
    display: grid;
    grid-template-columns: 1fr 1fr;
	grid-gap: 10px;
}
.test__option {
	.option {
		padding: 45px 5px 5px;
	}
}
</style>
